// DS9.7.5
import React from 'react';
import DeviationBlockedOverlay from './DeviationBlocked';
import ArtistBlockedOverlay from './ArtistBlocked';
import DefaultBlockedOverlay from './DefaultBlocked';
import AntisocialBlockedOverlay from './AntisocialBlocked';
import { BlockReasons } from '../../Moderation/redux/types';
import MatureAnonymousBlockedOverlay from './MatureAnonymousBlocked';
import MatureBlockedOverlay from './MatureBlocked';
import MatureAgeBlockedOverlay from './MatureAgeBlocked';
import MatureStrictBlockedOverlay from './MatureStrictBlocked';
import NsfgBlockedOverlay from './NsfgBlocked';
const BlockedOverlay = (props)=>{
    switch(props.blockReason){
        case BlockReasons.DeviationBlocked:
            return /*#__PURE__*/ React.createElement(DeviationBlockedOverlay, props);
        case BlockReasons.ArtistBlocked:
            return /*#__PURE__*/ React.createElement(ArtistBlockedOverlay, props);
        case BlockReasons.MatureFilter:
            return /*#__PURE__*/ React.createElement(MatureBlockedOverlay, props);
        case BlockReasons.MatureLoggedOut:
            return /*#__PURE__*/ React.createElement(MatureAnonymousBlockedOverlay, props);
        case BlockReasons.MatureAge:
            return /*#__PURE__*/ React.createElement(MatureAgeBlockedOverlay, props);
        case BlockReasons.StrictMatureAge:
            return /*#__PURE__*/ React.createElement(MatureStrictBlockedOverlay, props);
        case BlockReasons.Antisocial:
            return /*#__PURE__*/ React.createElement(AntisocialBlockedOverlay, props);
        case BlockReasons.Nsfg:
            return /*#__PURE__*/ React.createElement(NsfgBlockedOverlay, props);
        case BlockReasons.BlockedByArtist:
        default:
            return /*#__PURE__*/ React.createElement(DefaultBlockedOverlay, props);
    }
};
BlockedOverlay.displayName = 'BlockedOverlay';
export default BlockedOverlay;
